import React from "react";
import { usePermission } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import InitialScheduleTermTable from "./InitialScheduleTermTable";
import {
  listIntroductionPaymentTerms,
  getIntroductionPaymentTerms,
  createIntroductionPaymentTerms,
  updateIntroductionPaymentTerms,
  deleteIntroductionPaymentTerms,
  downloadIntroductionPaymentTerms,
  approveIntroductionPaymentTerms,
  makeIntroductionPaymentTermsLive,
} from "./actions";

const IntroductionPaymentTermsTable = ({ dealerId }) => {
  const canApprove = usePermission(
    Targets.IntroductionPayment,
    Actions.Approve,
  );
  const canDownload = usePermission(
    Targets.IntroductionPayment,
    Actions.Download,
  );

  return (
    <InitialScheduleTermTable
      dealerId={dealerId}
      title="Introduction Payment Terms"
      triggerText="Upload Introduction Payment Terms"
      listAction={listIntroductionPaymentTerms}
      getAction={getIntroductionPaymentTerms}
      createAction={createIntroductionPaymentTerms}
      updateAction={updateIntroductionPaymentTerms}
      deleteAction={deleteIntroductionPaymentTerms}
      downloadAction={downloadIntroductionPaymentTerms}
      approveAction={approveIntroductionPaymentTerms}
      makeLiveAction={makeIntroductionPaymentTermsLive}
      canApprove={canApprove}
      canDownload={canDownload}
    />
  );
};

export default IntroductionPaymentTermsTable;
